/**
 * React Query hook for recommended people ("People you might know").
 * Mirrors useFriendsQuery conventions. Disabled for guests / signed-out users.
 */

import { useQuery } from '@tanstack/react-query'
import { useApiClient } from '../../../helpers/apiClient.helper'
import { fetchFriendSuggestions } from '../helpers/friendsApi'

/**
 * @param userId - Viewer's user id (also the query-key scope)
 * @param enabled - Gate the query (pass `signedIn && !isGuest`)
 */
export const useFriendSuggestionsQuery = (userId: string, enabled: boolean = true) => {
  const apiClient = useApiClient()

  return useQuery({
    queryKey: ['friendSuggestions', userId],
    queryFn: async () => fetchFriendSuggestions(apiClient),
    enabled: enabled && !!userId,
    staleTime: 5 * 60 * 1000, // suggestions change slowly; 5 min
    gcTime: 10 * 60 * 1000,
  })
}
